module.exports = __webpack_public_path__ + "static/media/avatar.6bf79efb.png";